import React, { useEffect, useState, Fragment, useRef } from "react";
import { inject, observer } from "mobx-react";
import CountUp from "react-countup";
import axios from "axios";
import Confetti from "react-confetti";

import { AnalyticsEvent } from "../../components/elements/analytics-event";
import { set } from "react-ga";

const GTGOverlay = (props) => {
  const timer = useRef(0);
  const stop = useRef(0);
  const refresh = useRef(0);

  const [gtgTotal, setGTGTotal] = useState(0);
  const [gtgList, setGTGList] = useState([]);
  const [gtgArray, setGTGArray] = useState([]);
  const [gtgCompleted, setGTGCompleted] = useState([]);
  const [gtgNext, setGTGNext] = useState([]);
  const [gtgActive, setGTGActive] = useState([]);
  // const [effectsArray, setEffectsArray] = useState([]);
  // const [raised, setRaised] = useState(0);
  const [completedShow, setCompletedShow] = useState(false);

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/gtg/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.overlayStore.socketConnect(streamType, username, slug);

      receive();
      timer.current = setTimeout(() => start(), 10000);

      return () => props.overlayStore.socketDisconnect();
    }
  }, []);

  const { raised } = props.overlayStore;

  const receive = () => {
    const URL = process.env.REACT_APP_SERVICE_URI + "/getGTGMilestones";

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const goal = Number(urlParams.get("amount"));

    setGTGTotal(goal);

    axios
      .post(URL, { goal: goal })
      .then((response) => {
        setGTGList(
          response.data.map((gtg) => {
            return {
              id: gtg.id,
              amount: Number(gtg.value_rounded),
              provide: gtg.provide_cover,
              icon: gtg.icon,
              description: gtg.description,
            };
          })
        );
        // console.log("PG write", response);
      })
      .catch((err) => console.log("***** PG error:", err));
  };

  useEffect(() => {
    setGTGArray(
      gtgList.map((gtgArray, i, arr) => {
        const previousItem1 = arr[i - 1];
        const previousItem2 = arr[i - 2];
        const previousItem3 = arr[i - 3];

        const start =
          i === 1
            ? previousItem1.amount
            : i === 2
            ? previousItem1.amount + previousItem2.amount
            : i === 3
            ? previousItem1.amount + previousItem2.amount + previousItem3.amount
            : 0;

        const goal = start + gtgArray.amount;

        const thermpercent =
          i === 0
            ? Math.floor(
                100 * (parseFloat(raised) / parseFloat(gtgArray.amount))
              )
            : Math.floor(
                100 * (parseFloat(raised - start) / parseFloat(gtgArray.amount))
              );

        return {
          key: gtgArray.id,
          description: gtgArray.description,
          icon: gtgArray.icon,
          start: i === 0 ? 0 : start,
          amount: gtgArray.amount,
          goal: i === 0 ? gtgArray.amount : goal,
          active:
            i === 0
              ? gtgArray.amount > raised
                ? true
                : false
              : goal > raised
              ? true
              : false,
          progress: thermpercent,
          provide: gtgArray.provide,
        };
      })
    );
  }, [gtgList, raised]);

  // console.log(gtgArray);

  useEffect(() => {
    setGTGCompleted(gtgArray.filter((next) => !next.active));
    setGTGNext(gtgArray.filter((next) => next.active));
  }, [gtgArray]);

  // console.log(gtgCompleted);

  useEffect(() => {
    setGTGActive(gtgNext.shift());
  }, [gtgNext]);

  // useEffect(() => {
  //   if (gtgCompleted.length > 0 && gtgCompleted.length !== 4) {
  //     timer.current = setTimeout(() => start(), 10000);
  //     // start();
  //   }

  //   // return () => {
  //   //   clearTimeout(timer.current);
  //   // };
  // }, [gtgCompleted]);

  const start = () => {
    let items = document.querySelectorAll(".completed"),
      i;
    for (i = 0; i < items.length; i++) {
      items[i].style.animationDelay = [i] * 11 + "s";
    }
    // console.log("start ran");
    setCompletedShow(true);
    stop.current = setTimeout(() => restart(), 35000);
    // console.log("completed ran");
  };

  const restart = () => {
    setCompletedShow(false);
    refresh.current = setTimeout(() => start(), 300000);
    // console.log("refresh ran");
  };

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const formatNumber = (num) => {
    let value = num;
    const res = String(num).split(".");
    if (res.length === 1 || res[1].length <= 3) {
      value = value
        .toFixed(2)
        .replace(/\.00$/, "")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    return value;
  };

  // console.log("original", gtgArray);
  // console.log("completed", gtgCompleted);
  // console.log("next", gtgNext);
  // console.log("active", gtgActive);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const bgColor = urlParams.get("bgColor");

  return (
    <Fragment>
      {AnalyticsEvent("english", "/", "PLAY LIVE GTG Overlay")}
      {/* <p className="big_raised">${raised}</p> */}
      <div className="gtg-wrapper">
        {gtgActive !== undefined ? (
          <ul className="unfinished">
            {gtgCompleted.length > 0
              ? gtgCompleted.map((completed) => (
                  <li
                    key={completed.key}
                    className={
                      "completed" + `${completedShow === true ? " show" : ""}`
                    }
                  >
                    <div className="gtg-top">
                      <div className="text">
                        <span>Completed</span>
                      </div>
                      <div className={"icon " + `${completed.icon}`}></div>
                    </div>
                    <div className="gtg-middle">
                      <p>${formatNumber(Number(completed.amount))}</p>
                    </div>
                    <div className="gtg-bottom">
                      <p>
                        Could {completed.provide} {completed.description}
                      </p>
                    </div>
                  </li>
                ))
              : ""}
            {gtgActive !== undefined ? (
              <li className={`active ${gtgActive.icon} ${bgColor}`}>
                <div className={`gtg-top ${bgColor}`}>
                  {" "}
                  <p>
                    ${formatNumber(Number(gtgActive.amount))} could{" "}
                    {gtgActive.provide} {gtgActive.description}
                  </p>
                </div>
                <div className={`gtg-middle ${bgColor}`}>
                  <div className="amount">
                    <span className="amount_raised">
                      {/* <CountUp
                        start={raised - gtgActive.start}
                        end={raised - gtgActive.start}
                        duration={1}
                        separator=","
                        decimals={
                          raised -
                            gtgActive.start -
                            Math.floor(raised - gtgActive.start) !==
                          0
                            ? 2
                            : 0
                        }
                        preserveValue={true}
                        useEasing={false}
                      />{" "} */}
                      {/* {Number(raised - gtgActive.start).toFixed(2)} */}
                      {raised -
                        gtgActive.start -
                        Math.floor(raised - gtgActive.start) !==
                      0
                        ? formatter.format(raised - gtgActive.start)
                        : "$" + formatNumber(raised - gtgActive.start)}
                    </span>
                    <span className="amount_text">raised</span>
                  </div>
                  <div className={"icon " + `${gtgActive.icon}`}></div>
                </div>
                <div className="gtg-bottom">
                  <div className="gtg-therm-wrapper2">
                    <div className="gtg-therm-perc2">
                      <span>{gtgActive.progress}%</span>
                    </div>
                    <div className="gtg-therm-bar">
                      <div
                        className="gtg-therm-bar-inner"
                        style={{ width: `${gtgActive.progress}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              </li>
            ) : (
              ""
            )}
            {gtgNext.length > 0
              ? gtgNext.map((inactive, i) => (
                  <li key={inactive.key} className="inactive">
                    <div className="gtg-top">
                      <div className="text">
                        {i === 0 ? "Up Next: " : ""} $
                        {formatNumber(Number(inactive.amount))}
                      </div>
                      <div className={"icon grey " + `${inactive.icon}`}></div>
                    </div>
                  </li>
                ))
              : ""}
          </ul>
        ) : (
          <div
            className={`finished ${bgColor} ${
              gtgTotal === 3000 ||
              gtgTotal === 20000 ||
              gtgTotal === 50000 ||
              gtgTotal === 100000
                ? "big"
                : ""
            }`}
          >
            <div className="beams">
              {/* left beams */}
              <div className="beam long" />
              <div className="beam short" />
              <div className="beam short" />
              <div className="beam long" />
              <div className="beam long" />
              <div className="beam short" />
              <div className="beam short" />
              {/* right beams */}
              <div className="beam long" />
              <div className="beam short" />
              <div className="beam short" />
              <div className="beam long" />
              <div className="beam long" />
              <div className="beam short" />
              <div className="beam short" />
            </div>
            <div className="title">
              <span>CONGRATS!</span>
            </div>
            <div className="stars">
              <div className="star" />
              <div className="star" />
              <div className="star" />
            </div>
            <p className="raised_amount">
              <span>
                The <span>${formatNumber(raised)}</span> you raised
              </span>
              <span>could help provide</span>
            </p>
            {/* <div className="confetti" /> */}
            <Confetti
              width={425}
              height={386}
              numberOfPieces={50}
              gravity={0.05}
              colors={[
                "#8332a7",
                "#1874dc",
                "#64d0e4",
                "#c0da07",
                "#ffc32c",
                "#490e67",
                "#002856",
                "#1eadc1",
                "#75bc21",
                "#ffb125",
                "#c10f3a",
              ]}
            />
            <ul>
              {gtgCompleted.map((completed) => (
                <li key={completed.key}>
                  <div className={"icon grey " + `${completed.icon}`}></div>
                  <div className="text">{completed.description}</div>
                </li>
              ))}
            </ul>
            <p>for the kids of St. Jude</p>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default inject("overlayStore")(observer(GTGOverlay));
